import { useMemo } from 'react';

import type { ButtonConfigProps } from 'src/app/shared/components/RoundShareIconButton';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { mapButtonConfigs } from './mapButtonConfigs';
import type { Channel } from './types';
import { CHANNELS } from './types';
import { useShareOptions } from './useShareOptions';

type Result = ModelHookResult<{
	buttonConfigs: readonly ButtonConfigProps[];
}>;

export function useShareLinks(): Result {
	const options = useShareOptions();
	const availableShareActions = useAvailableShareActions(CHANNELS, options);
	return {
		data: {
			buttonConfigs: useMemo(() => mapButtonConfigs(availableShareActions), [availableShareActions]),
		},
	};
}

export type { Channel };
